const isPlainObject = (value: unknown): value is Record<string, unknown> =>
	typeof value === "object" &&
	value !== null &&
	!Array.isArray(value) &&
	!(value instanceof Date);

export const mergeDefined = <T>(target: T, source: unknown): T => {
	if (source === undefined) return target;
	if (!isPlainObject(source) || !isPlainObject(target)) return source as T;

	const merged: Record<string, unknown> = { ...target };

	for (const [key, value] of Object.entries(source)) {
		if (value === undefined) continue;
		merged[key] = mergeDefined(merged[key], value);
	}

	return merged as T;
};
